import styled from '@emotion/styled';
import { BaseContainer } from '@components/BaseContainer';
import { PAGE_PADDING_TOP } from '@constants';

export const BasePageContainer = styled(BaseContainer)`
  padding: ${PAGE_PADDING_TOP}px 20px 20px;
  background-color: ${({ theme }) => theme.colors.grey100};
`;
